var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullwidth",class:{'shadowed':_vm.b.box_shadow, 'widewidth':_vm.b.max}},[_c('img',{attrs:{"src":_vm.b.bild.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }